import { api } from "@/lib/api/axios";
import type { INotification } from "@/interfaces/notification.interface";

const NOTIFICATION_API_PATH = '/notifications';

export const notificationService = {
  getAll: async () => {
    return api.get<INotification[]>(NOTIFICATION_API_PATH);
  },

  getUnreadCount: async () => {
    return api.get<{ count: number }>(`${NOTIFICATION_API_PATH}/unread-count`);
  },

  markAsRead: async (id: string) => {
    return api.patch<INotification>(`${NOTIFICATION_API_PATH}/${id}/read`);
  },

  markAllAsRead: async (): Promise<{ message: string }> => {
    return api.patch<{ message: string }>(`${NOTIFICATION_API_PATH}/read-all`);
  },
};
